// Growem - mapeo puro fila day_state <-> modelo DayState.
//
// POR QUÉ existe este módulo (auditoría Fase 4, paso 11 del plan de sesión movible / CR9): estas
// dos funciones vivían inline en store.tsx, que importa ../lib/supabase y por eso no es cargable
// en vitest. dayToRow es el ÚNICO camino por el que un día viaja a la base, y es el vector de
// pérdida silenciosa de D7: si alguna vez dejara de serializar plan_day_index, un upsert cualquiera
// (agua, una serie) borraría el override de rutina movida sin que nadie lo note. Extraerlas a un
// módulo sin dependencias las deja bajo test (dayRow.test.ts congela el round-trip con override
// 0, movido y null).
//
// Contrato: cero lógica de negocio aquí. Solo renombre de columnas y defaults de lectura. El índice
// efectivo se decide en domain/planDay (planIdxOf); esta capa transporta el campo CRUDO tal cual,
// incluido null (que significa "sin override: manda el calendario").

import type { DayState } from '../types'

export type Row = Record<string, any>

export function rowToDay(r: Row): DayState {
  return {
    day: r.day,
    planDayIndex: r.plan_day_index ?? null,
    done: r.done ?? {},
    notes: r.notes ?? {},
    weights: r.weights ?? {},
    variants: r.variants ?? {},
    log: r.log ?? {},
    water: r.water_ml ?? 0,
    creatine: !!r.creatine,
    prot: r.protein_g ?? 0,
    kcal: r.kcal ?? 0,
    carbs: r.carbs_g ?? 0,
    fat: r.fat_g ?? 0,
    sleep: r.sleep_stretch ?? null,
    weight: r.bodyweight_kg ?? null,
    trainAt: r.train_at ?? null,
  }
}

export function dayToRow(d: DayState, userId: string): Row {
  return {
    // plan_day_index SIEMPRE presente (aunque sea null): un upsert de fila entera que lo omitiera
    // dejaría el valor previo de la DB, pero uno que lo mandara undefined/ausente en otro cliente
    // podría pisarlo. Serializarlo incondicionalmente es la garantía de D7.
    user_id: userId, day: d.day, plan_day_index: d.planDayIndex,
    done: d.done, notes: d.notes, weights: d.weights, variants: d.variants, log: d.log,
    water_ml: d.water, creatine: d.creatine, protein_g: d.prot, kcal: d.kcal,
    carbs_g: d.carbs, fat_g: d.fat, sleep_stretch: d.sleep,
    bodyweight_kg: d.weight, train_at: d.trainAt,
  }
}
